import { Box, Button, CircularProgress, Dialog, DialogContent, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import WhiteInosio from '../../icons/whiteinosio.svg';
import { PaymentRequestBalanceDto, Role } from '@inosio/payments-sdk';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getPasswordLogin, selectAuthState, clearCredentials } from '../sagas/auth/authSlice';
import InputControllerLogin from '../../components/Form/InputControllerLogin';
import { ChangeEvent, useState } from 'react';
import { EmailRegex } from '../../utils/regex';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import BackIcon from '../../icons/back1.svg';

interface LoginModalProp {
  open: boolean;
  onBackClick: () => void;
  signUp: () => void;
  PaymentRequestDetails: PaymentRequestBalanceDto | null;
}

interface State {
  email: string;
  password: string;
  showPassword: boolean;
}

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    background: '#FFFFFF',
    borderRadius: '24px',
  },
  rightContainer: {
    background: '#053742',
    width: '59%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  leftContainer: {
    borderRadius: '24px 0px 0px 24px',
    background: '#ffffff',
    width: '42%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '30px',
  },
  brandTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '36px',
  },
  brandText: {
    fontFamily: 'BMWHelvetica',
    fontWeight: 700,
    fontSize: '24px',
  },
  formContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    width: '340px',
    border: 'none',
  },
  buttonContainer: {
    width: '340px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    marginTop: '20px',
    paddingBottom: '20px',
  },
  wrapper: {
    margin: '1px',
    position: 'relative',
  },
  buttonProgress: {
    color: '#053742',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  globalError: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '30px',
    borderTop: '2px  solid #DB3939',
    borderRadius: '24px',
    padding: '12px 20px',
    width: '340px',
    height: '49px',
  },
  btnStyle: {
    font: '14px Work Sans 400 !important',
    width: '113px',
    height: '49px',
    borderRadius: '24px !important',
    textTransform: 'capitalize',
    backgroundColor: '#39A2DB',
    color: '#FFFFFF !important',
  },
  btnStyleMobileScreen: {
    font: '14px Work Sans !important',
    width: '100%',
    height: '49px',
    borderRadius: '24px !important',
    textTransform: 'capitalize',
  },
  newAccountText: {
    color: 'rgba(211, 211, 211, 1)',
    marginLeft: '25px',
    fontSize: '16px',
    marginBottom: '5px',
  },
  isActive: {
    background: 'rgba(57, 162, 219, 1) !important',
    boxShadow: ' 0px 0px 40px rgba(0, 0, 0, 0.1) !important',
    color: '#fff !important',
  },
  isNotActive: {
    background: 'rgba(211, 211, 211, 1) !important',
    boxShadow: ' 0px 0px 40px rgba(0, 0, 0, 0.1) !important',
  },
  brandContainerMobileScreen: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    marginBottom: '30px',
  },
  brandTextMobileScreen: {
    fontSize: '20px !important',
  },
  buttonContainerMobileScreen: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    marginTop: '170px',
    paddingBottom: '20px',
  },
  signUpBtn: {
    font: '14px Work Sans !important',
    border: '1px solid #39A2DB !important',
    width: '113px',
    height: '49px',
    borderRadius: '24px !important',
  },
  forgetText: {
    font: '14px Work Sans',
    lineHeight: '30px',
    color: '#39A2DB',
    textDecoration: 'none !important',
    maxHeight: '30px !important',
    margin: '10px !important',
    marginTop: '8px !important',
    marginBottom: '27px !important',
    paddingLeft: '5px !important',
    cursor: 'pointer',
    zIndex: 30,
  },
  signUpBtnOnMobile: {
    font: '14px Work Sans !important',
    border: '1px solid #39A2DB !important',
    width: '100%',
    height: '49px',
    borderRadius: '24px !important',
  },
}));

const LoginModal = (props: LoginModalProp) => {
  const isOnMobileScreen = useMediaQuery('(max-width:600px)');
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isFetching, isSuccess, isError, errorMessage, ipaUser } = useSelector(selectAuthState);

  const [values, setValues] = React.useState<State>({
    email: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (prop: keyof State) => (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');
  const [globalError, setGlobalError] = useState('');

  const class1 = !isOnMobileScreen ? classes.btnStyle : classes.btnStyleMobileScreen;

  const class2 = classes.isActive;

  const validateEmail = (inputedEmail: string) => {
    if (!inputedEmail) {
      setEmailError(() => 'Email address is empty!');
      return false;
    } else if (!EmailRegex.test(inputedEmail.trim())) {
      setEmailError(() => 'Invalid email address!');
      return false;
    }
    setEmailError('');
    return true;
  };

  const validatePassword = (inputtedPassword: string) => {
    if (inputtedPassword.length === 0) {
      setPassError('Password is empty!');
      return false;
    } else {
      setPassError('');
      return true;
    }
  };

  const handleSubmit = (event: any) => {
    event?.preventDefault();

    if (validateEmail(values.email) && validatePassword(values.password)) {
      dispatch({
        type: getPasswordLogin.type,
        payload: {
          email: values.email.trim(),
          password: values.password,
        },
      });
    }
  };

  const { open, onBackClick, PaymentRequestDetails, signUp } = props;
  const style = {
    height: isOnMobileScreen ? '100%' : '523px',
  };

  useEffect(() => {
    if (isError) {
      setGlobalError('The email or password is invalid. Please try again');
    }

    if (isSuccess) {
      if (ipaUser?.mustChangePassword) {
        history.push({
          pathname: '/changepassword',
          state: {
            mustChangePassword: true,
            username: ipaUser?.username,
            oldPassword: values.password,
          },
        });

        dispatch(clearCredentials());
        return;
      }

      if (ipaUser?.currentProfile.role && [Role.InosioAdmin, Role.InosioStaff].includes(ipaUser?.currentProfile.role)) {
        history.push('/adminportal');

        return;
      }

      if (ipaUser?.currentProfile.role && ipaUser?.currentProfile.role === Role.Resident) {
        history.push('/resui/payments');

        return;
      }
      if (ipaUser?.currentProfile.role && [Role.PropertyManager, Role.PropertyManagerAdmin].includes(ipaUser?.currentProfile.role)) {
        history.push('/pmui/transactions');

        return;
      }

      const principal = ipaUser?.profiles.find((p) => p.uuid === ipaUser?.currentProfile.role);

      if (principal?.role === Role.PropertyManagerAdmin || principal?.role === Role.PropertyManager) {
        history.push('/pmui');
      } else if (principal?.role === Role.Resident) {
        history.push('/resui/payments');
      }
    }
  }, [isError, errorMessage, isSuccess, ipaUser, dispatch, history]);

  return (
    <Dialog
      open={open}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: true,
      }}
      fullWidth={true}
      disableEnforceFocus
      style={{
        background: 'none',
      }}
      PaperProps={{
        style: {
          pointerEvents: 'auto',
          borderRadius: isOnMobileScreen ? '0px' : '24px',
          width: isOnMobileScreen ? '100%' : '472px',
          boxShadow: 'none',
          overflow: 'hidden',
        },
      }}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <div className={classes.leftContainer}>
          {globalError.length ? (
            <div className={classes.globalError}>
              <Typography
                style={{
                  fontFamily: 'BMWHelvetica',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '18px',
                  color: '#DB3939',
                }}
              >
                {' '}
                {globalError}
              </Typography>
            </div>
          ) : (
            ''
          )}

          <Box sx={style}>
            <Grid item display="flex" flexDirection="column" alignItems="center" sx={{ height: '100%' }}>
              <Grid item display="flex" justifyContent="center">
                <Grid item display="flex" pl={6} sx={{ width: '340px' }} justifyContent="center" mt={12} mb={8}>
                  <img src={WhiteInosio} style={{ width: '75px', height: '75px' }} alt="logo" />
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '18px',
                      lineHeight: '23px',
                      color: '#14142B',
                      textAlign: 'left',
                      padding: '15px',
                    }}
                  >
                    {PaymentRequestDetails?.CompanyName}
                  </Typography>
                </Grid>
              </Grid>
              <Box component="form" onSubmit={handleSubmit} noValidate className={classes.formContainer} display="flex" flexDirection="column" alignItems="center">
                <Grid item>
                  <Grid item>
                    <InputControllerLogin
                      name={'email'}
                      value={values.email}
                      label={'Email'}
                      onChange={handleChange('email')}
                      autoComplete="email"
                      isError={!!emailError.length}
                      errors={emailError}
                      isfullWidth={true}
                    />
                  </Grid>
                  <Grid item display="flex">
                    <InputControllerLogin
                      name={'password '}
                      label={'Password'}
                      onChange={handleChange('password')}
                      required={true}
                      autoComplete="password"
                      isError={!!passError.length}
                      errors={passError}
                      value={values.password}
                      isfullWidth={true}
                      type="password"
                    />
                  </Grid>
                </Grid>
                <Grid className={`${!isOnMobileScreen ? classes.buttonContainer : classes.buttonContainerMobileScreen}`}>
                  {!isOnMobileScreen ? (
                    <Grid item>
                      <Button onClick={signUp} className={classes.signUpBtn}>
                        Sign Up
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item pb={1}>
                      <Button className={classes.signUpBtnOnMobile} onClick={signUp}>
                        Sign Up
                      </Button>
                    </Grid>
                  )}
                  <Grid item>
                    <Button disabled={isFetching} type="submit" className={`${class1} ${class2}`}>
                      Sign in
                    </Button>
                    {isFetching ? (
                      <CircularProgress
                        size={26}
                        sx={{
                          color: '#39A2DB',
                        }}
                        className={classes.buttonProgress}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Box>
          <Grid item sx={{ position: 'absolute', top: 15, left: 15 }}>
            <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={onBackClick} />
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoginModal;
